<div fxLayout="column">
  <label for="datepick" >Birth Date</label>
  <input type="date" id="datepick" [value]="dateValue">
</div>